import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { handle } from "@dp/common";
var BEGINPUBLICKEY = "-----BEGIN PUBLIC KEY-----\n";
var ENDPUBLICKEY = "\n-----END PUBLIC KEY-----";
export function str2ab(str) {
  var buf = new ArrayBuffer(str.length);
  var bufView = new Uint8Array(buf);

  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }

  return buf;
}

function getSpkiDer(_x) {
  return _getSpkiDer.apply(this, arguments);
}

function _getSpkiDer() {
  _getSpkiDer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(spkiPem) {
    var pemHeader, pemFooter, pemContents, binaryDerString;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pemHeader = BEGINPUBLICKEY;
            pemFooter = ENDPUBLICKEY;
            pemContents = spkiPem.substring(pemHeader.length, spkiPem.length - pemFooter.length);
            binaryDerString = window.atob(pemContents);
            return _context.abrupt("return", str2ab(binaryDerString));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getSpkiDer.apply(this, arguments);
}

function importPublicKey(_x2) {
  return _importPublicKey.apply(this, arguments);
}

function _importPublicKey() {
  _importPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(spkiPem) {
    var spkider;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSpkiDer(spkiPem);

          case 2:
            spkider = _context2.sent;
            return _context2.abrupt("return", window.crypto.subtle.importKey("spki", spkider, {
              name: "RSA-OAEP",
              hash: "SHA-512"
            }, true, ["encrypt"]));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _importPublicKey.apply(this, arguments);
}

function initPublicKey(_x3) {
  return _initPublicKey.apply(this, arguments);
}

function _initPublicKey() {
  _initPublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
    var publKey;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            publKey = BEGINPUBLICKEY + key + ENDPUBLICKEY;
            return _context3.abrupt("return", importPublicKey(publKey));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _initPublicKey.apply(this, arguments);
}

function encryptRSA(_x4, _x5) {
  return _encryptRSA.apply(this, arguments);
}

function _encryptRSA() {
  _encryptRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, plaintext) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", window.crypto.subtle.encrypt({
              name: "RSA-OAEP"
            }, key, plaintext));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _encryptRSA.apply(this, arguments);
}

function arrayBufferToString(buffer) {
  return String.fromCharCode.apply(null, Array.from(new Uint8Array(buffer)));
}

function doEncrypt(_x6, _x7) {
  return _doEncrypt.apply(this, arguments);
}

function _doEncrypt() {
  _doEncrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(plaintext, pubKey) {
    var encrypted;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return encryptRSA(pubKey, new TextEncoder().encode(plaintext));

          case 3:
            encrypted = _context5.sent;
            return _context5.abrupt("return", "ENC_[" + window.btoa(arrayBufferToString(encrypted)) + "]");

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", "");

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));
  return _doEncrypt.apply(this, arguments);
}

export function encryptAccount(_x8, _x9) {
  return _encryptAccount.apply(this, arguments);
}

function _encryptAccount() {
  _encryptAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(encryptionFields, rsaToken) {
    var pubKey;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return handle(initPublicKey(rsaToken.publicKey).then(function (pub) {
              pubKey = pub;
              return doEncrypt(encryptionFields.paymentCardToken, pubKey);
            }).then(function (paymentCardToken) {
              encryptionFields.paymentCardToken = paymentCardToken;
              return doEncrypt(encryptionFields.securityCode, pubKey);
            }).then(function (securityCode) {
              encryptionFields.securityCode = securityCode;
              return doEncrypt(encryptionFields.expirationMonth, pubKey);
            }).then(function (expirationMonth) {
              encryptionFields.expirationMonth = expirationMonth;
              return doEncrypt(encryptionFields.expirationYear, pubKey);
            }).then(function (expirationYear) {
              encryptionFields.expirationYear = expirationYear;
            }));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _encryptAccount.apply(this, arguments);
}